//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import defaultimg from '@/assets/shuping/book.png'
import defautphoto from '@/assets/timg.jpg'
import { List } from 'vant'
import { getAllBook, getAllCommentNum, getComment, addReadcnt } from '@/api/shuping'
export default {
  props: {},
  components: {
    [List.name]: List
  },
  data () {
    return {
      defautphoto: defautphoto,
      defaultimg: defaultimg,
      baseUrl: this.$config.baseUrl,
      id: this.$route.params.id,
      partyid: this.$route.params.partyid,
      booklist: '',
      numslist: [],
      firstcomment: [],
      page: 1,
      rows: 20,
      loading: false,
      finished: false
    }
  },
  created () {
    this.addlog()
  },
  mounted () {
    // this.getlist()
  },
  methods: {
    addlog () {
      addReadcnt({
        id: this.id
      })
    },
    getlist () {
      getAllBook({
        numberid: this.id,
        partyid: this.partyid,
        page: this.page,
        rows: this.rows
      }).then(data => {
        this.allnums = data.obj.allCount || []
        this.booklist = [...this.booklist, ...data.obj.list]
        this.page++
        this.loading = false
        console.log(this.booklist.length)
        if (this.booklist.length >= this.allnums) {
          this.finished = true
        }
        // var idlist = []
        // data.obj.list.forEach(el => {
        //   idlist.push(el.id)
        // })
        // var promiseArr = idlist.map(item => {
        //   return new Promise((resolve, reject) => {
        //     getAllCommentNum({ bookid: item }).then(res => {
        //       resolve(res.obj) // id查询num
        //     })
        //   })
        // })
        // var promiseArr2 = idlist.map(item => {
        //   return new Promise((resolve, reject) => {
        //     getComment({ bookid: item }).then(res => {
        //       resolve(res.obj) // id查询objecto9
        //     }, e => {
        //       console.log(e)
        //     })
        //   })
        // })
        // console.log(promiseArr2)
        // Promise.all(promiseArr).then(res => {
        //   this.numslist = [...this.numslist, ...res]
        // })
        // Promise.all(promiseArr2).then(res => {
        //   this.firstcomment = [...this.firstcomment, ...res]
        // }, e => {
        //   console.log(e)
        // })
      })
    },
    linktoall (id) {
      this.$router.push({ name: 'commentDetail', params: { bookid: id } })
    }
  }
}
